import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  loadUpdatedData,
  loadImportedData
} from '../../../redux/action/import/ImportActions';
import {
  Button,
  Form,
  Input,
  Modal,
  Spin,
  Icon,
  Upload,
  message,
  notification
} from 'antd';
import PropTypes from 'prop-types';
import _ from 'lodash';

class UpdateImportModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      inputValue: '',
      fileList: [],
      uploading: false,
      importing: false
    };
  }

  sendHandler = () => {
    const { modalStatus, selectKey, setLoader } = this.props;

    const requestData = this.prepareRequestData(selectKey);
    const isInputEmpty = !this.state.inputValue.trim();

    if (selectKey === 'imagesStatuses') setLoader(true);

    if (modalStatus === 'update') {
      if (!isInputEmpty) {
        Promise.resolve(
          this.props.loadUpdatedData(selectKey, requestData)
        ).then(() => {
          if (
            this.props.loadUpdatedResponse &&
            selectKey !== 'imagesStatuses'
          ) {
            const {
              created,
              existed,
              existedDomains,
              notValid,
              notValidDomains
            } = this.props.loadUpdatedResponse;

            notification.info({
              message: 'Result',
              description: (
                <ul style={{ paddingLeft: 0, listStyleType: 'none' }}>
                  <li>Domains added to blacklist: {created}</li>
                  {existed ? (
                    <li>
                      Domains are already on the blacklist: {existed} (
                      {existedDomains.join(', ')})
                    </li>
                  ) : null}
                  {notValid ? (
                    <li>
                      Not valid domains: {notValid} (
                      {notValidDomains.join(', ')})
                    </li>
                  ) : null}
                </ul>
              ),
              duration: 0
            });
          }

          if (
            selectKey === 'imagesStatuses' &&
            _.isObject(this.props.loadUpdatedResponse) &&
            _.isEmpty(this.props.loadUpdatedResponse)
          ) {
            setTimeout(() => message.error(`Update failed!`), 7000);
          } else if (
            selectKey === 'imagesStatuses' &&
            !this.props.loadImportedErrorMessage.message
          ) {
            setTimeout(() => {
              notification.info({
                message: 'Result',
                description: (
                  <ul style={{ paddingLeft: 0, listStyleType: 'none' }}>
                    <li>Updated Successfully</li>
                  </ul>
                ),
                duration: 0
              });
            }, 7000);
          }
        });
      } else {
        message.error(`Update failed!`);
      }
    }

    if (modalStatus === 'import') {
      const { fileList } = this.state;

      if (!_.isEmpty(fileList)) {
        this.setState({ importing: true });

        Promise.resolve(
          this.props.loadImportedData(selectKey, fileList[0])
        ).then(() => {
          this.setState({ importing: false });

          const response = this.props.loadImportedResponse;
          const errorResponse = this.props.loadImportedErrorMessage;

          // Handle new response format
          if (response && typeof response === 'object' && response.hasOwnProperty('success')) {
            const { success, message: responseMessage, notFoundFile, notFoundOriginalResults, fileName } = response;

            if (success) {
              // Show success notification
              notification.success({
                message: 'Import Successful',
                description: responseMessage || 'File imported successfully',
                duration: 4
              });
            } else {
              // Show warning notification with the message from server
              notification.warning({
                message: 'Import Completed with Issues',
                description: responseMessage || 'Import completed but some items could not be processed',
                duration: 6
              });

              // If there are not found originals, show additional info
              if (notFoundOriginalResults && notFoundOriginalResults.length > 0) {
                const downloadNotFoundFile = () => {
                  if (notFoundFile) {
                    try {
                      // Decode base64 string and create downloadable file
                      const byteCharacters = atob(notFoundFile);
                      const byteNumbers = new Array(byteCharacters.length);
                      for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                      }
                      const byteArray = new Uint8Array(byteNumbers);
                      const blob = new Blob([byteArray], { type: 'text/csv' });

                      // Create download link
                      const url = window.URL.createObjectURL(blob);
                      const link = document.createElement('a');
                      link.href = url;
                      link.download = fileName || 'not_found_items.csv';
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                      window.URL.revokeObjectURL(url);

                      message.success('File downloaded successfully');
                    } catch (error) {
                      message.error('Failed to download file');
                    }
                  }
                };

                notification.info({
                  message: 'Not Found Items Details',
                  description: (
                    <div>
                      <p>Found {notFoundOriginalResults.length} items that could not be processed:</p>
                      <ul style={{ maxHeight: '150px', overflow: 'auto', margin: '10px 0', padding: '0 20px' }}>
                        {notFoundOriginalResults.slice(0, 5).map((item, index) => (
                          <li key={index}>
                            {typeof item === 'object'
                              ? `Agency: ${item.agency}, ImageId: ${item.imageId}`
                              : item}
                          </li>
                        ))}
                        {notFoundOriginalResults.length > 5 && (
                          <li>... and {notFoundOriginalResults.length - 5} more items</li>
                        )}
                      </ul>
                      {notFoundFile && (
                        <Button
                          type="link"
                          size="small"
                          onClick={downloadNotFoundFile}
                          style={{ padding: 0, marginTop: '10px' }}
                        >
                          Download CSV with all not found items ({fileName})
                        </Button>
                      )}
                    </div>
                  ),
                  duration: 0
                });
              }
            }
          } else {
            // Handle old response format for backward compatibility
            if (response && response.message) {
              const importResponse = Array.isArray(response.message)
                ? response.message.join().replace(/^\w/, (f) => f.toUpperCase())
                : response.message;
              message.success(importResponse);
            } else if (errorResponse && errorResponse.message) {
              const importResponseError = Array.isArray(errorResponse.message)
                ? errorResponse.message.join().replace(/^\w/, (f) => f.toUpperCase())
                : errorResponse.message;
              message.error(importResponseError);
            }

            if (
              (selectKey === 'imagesStatuses' ||
                selectKey === 'countries' ||
                selectKey === 'agency') &&
              !errorResponse?.message
            ) {
              setTimeout(() => {
                notification.info({
                  message: 'Result',
                  description: (
                    <ul style={{ paddingLeft: 0, listStyleType: 'none' }}>
                      <li>Imported Successfully</li>
                    </ul>
                  ),
                  duration: 0
                });
              }, 7000);
            }
          }
        }).catch(() => {
          this.setState({ importing: false });
          message.error('Import failed due to network error');
        });
      } else {
        message.error(`Please select a CSV file to import`);
      }
    }

    if (selectKey === 'imagesStatuses')
      setTimeout(() => setLoader(false), 7000);
  };

  prepareRequestData = (selectKey) => {
    const value = this.state.inputValue.split('\n');
    const objValues = value.map((str) => str.split(','));
    const statusObjValues = value.map((str) => str.split(';'));

    if (selectKey === 'imagesNotPursuable') {
      const objVal = objValues.map((val) => {
        return (
          val.length && {
            agency: val[0],
            imageId: val[1]
          }
        );
      });
      return objVal;
    }

    if (selectKey === 'imagesRegistered') {
      const objVal = objValues.map((val) => {
        return (
          val.length && {
            imageId: val[0],
            agency: val[1],
            registered: val[2],
            registrationNumber: val[3]
          }
        );
      });
      return objVal;
    }

    if (selectKey === 'domainsBlacklisted') {
      const objVal = objValues.map((val) => {
        return (
          val.length && {
            domain: val[0]
          }
        );
      });
      return objVal;
    }

    if (selectKey === 'imagesStatuses') {
      const objVal = statusObjValues.map((val) => {
        return (
          val.length && {
            id: val[0],
            status: val[1]
          }
        );
      });
      return objVal;
    }

    if (selectKey === 'subdomainsBlacklisted') {
      const objVal = objValues.map((val) => {
        return (
          val.length && {
            domain: val[0]
          }
        );
      });
      return objVal;
    }
  };

  cancelHandler = () => {
    const form = this.props.form;
    form.resetFields();
    this.props.onCancel();

    this.setState({
      fileList: [],
      importing: false
    });
  };

  changeHandler = (e) => {
    this.setState({
      inputValue: e.target.value
    });
  };

  render() {
    const {
      loaderIsVisible,
      isVisible,
      getImportFormatData,
      modalStatus,
      selectKey
    } = this.props;
    const { getFieldDecorator } = this.props.form;
    const { fileList } = this.state;

    let title =
      modalStatus === 'update' ? 'ADD AND UPDATE ITEMS' : 'IMPORT ITEMS';

    if (selectKey === 'agency') {
      title = 'Import Legitimate Agency CSV';
    }

    if (selectKey === 'countries') {
      title = 'Import Countries CSV';
    }

    const uploadProps = {
      onRemove: (file) => {
        this.setState((state) => {
          const index = state.fileList.indexOf(file);
          const newFileList = state.fileList.slice();
          newFileList.splice(index, 1);
          return {
            fileList: newFileList
          };
        });
      },
      beforeUpload: (file) => {
        _.isEmpty(this.state.fileList)
          ? this.setState((state) => ({
            fileList: [...state.fileList, file]
          }))
          : this.setState(() => ({
            fileList: [file]
          }));
        return false;
      },
      fileList,
      multiple: false
    };

    return (
      <Modal
        title={title}
        visible={isVisible}
        onCancel={this.state.importing ? null : this.cancelHandler}
        keyboard={!this.state.importing}
        maskClosable={!this.state.importing}
        closable={!this.state.importing}
        destroyOnClose={true}
        footer={[
          <Button
            key='back'
            loading={loaderIsVisible}
            disabled={this.state.importing}
            onClick={this.cancelHandler}
          >
            Cancel
          </Button>,
          <Button
            key='submit'
            type='primary'
            loading={loaderIsVisible || this.state.importing}
            disabled={this.state.importing}
            onClick={() => this.sendHandler()}
          >
            {this.state.importing ? 'Importing' : (modalStatus === 'update' ? 'Update' : 'Import')}
          </Button>
        ]}
      >
        <Spin size='large' spinning={loaderIsVisible}>
          <Form layout='vertical' prefixCls='add_new_user_'>
            <Form.Item style={{ marginBottom: 0 }}>
              {getImportFormatData && this.props.selectKey === 'imagesRegistered' && getImportFormatData.format ? (
                <div>
                  <h4
                    style={{
                      marginBottom: 0,
                      lineHeight: '1.5rem'
                    }}
                  >
                    Example data:
                  </h4>
                  <pre style={{
                    backgroundColor: '#f5f5f5',
                    padding: '10px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    lineHeight: '1.5rem',
                    overflowX: 'auto',
                    whiteSpace: 'pre-wrap'
                  }}>{typeof getImportFormatData.format === 'string' ? getImportFormatData.format : (Array.isArray(getImportFormatData.format) ? getImportFormatData.format.join('') : '')}</pre>
                </div>
              ) : getImportFormatData && getImportFormatData.format ? (
                _.map(getImportFormatData.format, (example, i) => (
                  <div key={i}>
                    <h4
                      style={{
                        marginBottom: 0,
                        lineHeight: '1.5rem'
                      }}
                    >
                      Example data:
                    </h4>
                    <ul>
                      {example.split('\n').map((str, i) => (
                        <li
                          style={{
                            lineHeight: '1.5rem'
                          }}
                          key={i}
                        >
                          {str}
                        </li>
                      ))}
                      {this.props.selectKey === 'imagesStatuses' && (
                        <>
                          <li
                            style={{
                              lineHeight: '1.5rem'
                            }}
                          >
                            IDENTICAL,
                          </li>
                          <li
                            style={{
                              lineHeight: '1.5rem'
                            }}
                          >
                            NOT_IDENTICAL,
                          </li>
                        </>
                      )}
                    </ul>
                  </div>
                ))
              ) : null}
              {title === 'ADD AND UPDATE ITEMS' ? (
                getFieldDecorator('domain', {
                  rules: [
                    {
                      required: true,
                      message: 'This field cannot be empty.'
                    }
                  ]
                })(
                  <Input.TextArea
                    onChange={this.changeHandler}
                    autoSize={{ minRows: 6, maxRows: 20 }}
                  />
                )
              ) : (
                <Upload {...uploadProps}>
                  <Button className='import-choose'>
                    <Icon type='upload' />
                    <span>Choose file</span>
                  </Button>
                </Upload>
              )}
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }
}

UpdateImportModal.propTypes = {
  isVisible: PropTypes.bool,
  loaderIsVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  onCreate: PropTypes.func,
  setLoader: PropTypes.func
};

function mapStateToProps({ importStore }) {
  return {
    loadUpdatedResponse: importStore.loadUpdatedResponse,
    loadImportedResponse: importStore.loadImportedResponse,
    loadUpdatedErrorMessage: importStore.loadUpdatedErrorMessage,
    loadImportedErrorMessage: importStore.loadImportedErrorMessage,
    getImportFormatData: importStore.getImportFormatData
  };
}

function mapDispatchToProps(dispatch) {
  return {
    loadUpdatedData: bindActionCreators(loadUpdatedData, dispatch),
    loadImportedData: bindActionCreators(loadImportedData, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Form.create({ name: 'UpdateImportModal' })(UpdateImportModal));
